import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { respond } from '../../theme/mixins';

function NavItem({ as, children, ...props }) {
  const Component = as || 'div';
  return (
    <Component css={styles.wrapper} {...props}>
      {children}
    </Component>
  );
}

const styles = {
  wrapper: css`
    inline-size: calc(100% + 1rem);
    padding: 1rem 1rem 0.75rem;
    margin-inline-start: -1rem;
    background-color: var(--color-default-background);

    ${respond(`
      inline-size: calc(100% + 2rem);
      margin-inline-end: -1rem;
    `)}
  `,
};

NavItem.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
};

export default NavItem;
